// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bej_a bhe_bk bhe_bl bhe_bo","SwipeLeftToClose--animating":"bej_b"};